class Login 
    extends QueryElement<HTMLElement> {

    private readonly _translate: Translate;
    private readonly _repository: RavenDbClient;
    private readonly _login: IQueryElement;
    private readonly _text: IQueryElement;
    private readonly _error: IQueryElement;
    private readonly _keyboard: SiteKeyboard;

    constructor(element: HTMLElement) {
        super(element);
        
        document.documentElement.classList.add("light");
        this._translate = new Translate("nl");
        this._repository = new RavenDbClient({
            database: "Kassa",
            url: "https://database-cluster03-server07.production.svc.cluster.local:10307"
        })

        var keyboard = new Query("#keyboard").create<SiteKeyboard, HTMLElement>(a => new SiteKeyboard(a))
            ?? throwError("Keyboard element not found");

        var submit = this.query('button[type="submit"]').first() 
            ?? throwError("Submit element not found");
        this._login = this.query(".login").first()
            ?? throwError("Login element not found");
        this._text = this.query(".text").first()
            ?? throwError("Text element not found");
        this._error = this.query(".login .error").first()
            ?? throwError("Error element not found");
        
        this._keyboard = keyboard;
        
        // Add events
        submit.on("click", async () => { 
            await this.checkDatabase(); 
        });
    }

    async init() {
        await this._translate.init();
        await this._keyboard.setDefaultLayout("us");
        Translator.translate(this, this._translate);

        this.checkDatabase();
    }

    showLogin() {
        this.addClass("show-login");
    }
    showMessage(message: string) {
        this.removeClass("show-login");
        this._text.setHtml(`<h1>${message}</h1>`);
    }
    showError(message: string) {
        this._error.addClass("show");
        this._error.setHtml(message);
    }

    async checkDatabase() {
        this.showMessage(this._translate.translate("_LOGGING_IN"));

        if (true) {
            // Handover to site
            var site = document.getElementById("site")
                ?? throwError("Site not found!");
            
            new Site(site, this._translate, this._repository, this._keyboard);
            
            // Hide myself
            this.addClass("hide");
        } else {
            this.showLogin();
            this.showError(this._translate.translate("_LOGIN_ERROR"));
        }
    }
}